import { render, staticRenderFns } from "./skuUpdate.vue?vue&type=template&id=6fc2d4f2&"
import script from "./skuUpdate.vue?vue&type=script&lang=js&"
export * from "./skuUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports